import styles from './styles.module.scss';
import { Props } from './types';

const TextArea = ({ label, value, placeholder, onChange, error }: Props) => {
  return (
    <div className={styles.container}>
      <span className={styles.label}>{label}</span>
      <textarea
        className={styles.textarea}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
      />
      {error ? (
        <span className={styles.error}>{error}</span>
      ) : (
        <div className={styles.placeholder} />
      )}
    </div>
  );
};

export default TextArea;
